import React, { forwardRef } from 'react';

const DialogCloseButton = forwardRef(
  ({ className, onClick, img, alt, width, height }, ref) => {
    const onKeyDown = e => {
      if (e.key === 'Enter') {
        e.preventDefault();
        onClick();
      }
    };

    return (
      <button
        className={`dialogComponent closeDialogButton ${className}`}
        tabIndex="0"
        onKeyDown={onKeyDown}
        aria-label="Close"
        role="button"
        ref={ref}
      >
        <img
          src={`/content/images/icons/${img}`}
          alt={alt}
          height={height}
          width={width}
          onClick={onClick}
        />
      </button>
    );
  }
);

export default DialogCloseButton;
